import { MutationTuple } from "@apollo/client";

import { FragmentType, getFragmentData, graphql } from "@/__generated__";
import {
  MUserProfilePage_UpdateProfileMutation,
  MUserProfilePage_UpdateProfileMutationVariables,
} from "@/__generated__/graphql";
import Section from "@/components/shared/Section";

import DetailsForm from "./DetailsForm";
import Emails from "./Emails";
import Token from "./Token";

const UserProfileGeneral_User = graphql(`
  fragment UserProfileGeneral_User on User {
    ...UserProfileEmails_User
    ...UserProfileDetailsForm_User
    ...UserProfileToken_User
  }
`);

interface Props {
  user: FragmentType<typeof UserProfileGeneral_User>;
  updateProfileMutation: MutationTuple<
    MUserProfilePage_UpdateProfileMutation,
    MUserProfilePage_UpdateProfileMutationVariables
  >;
}

export default function General({ updateProfileMutation, ...props }: Props) {
  const user = getFragmentData(UserProfileGeneral_User, props.user);
  return (
    <Section heading="General">
      <DetailsForm updateProfileMutation={updateProfileMutation} user={user} />
      <Token user={user} />
      <Emails updateProfileMutation={updateProfileMutation} user={user} />
    </Section>
  );
}
